import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import _ from "lodash";
import { useFormik } from "formik";
import { useDropzone } from "react-dropzone";
import * as yup from "yup";
import dayjs from "dayjs";
//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import moment from "moment";

//Services
import PromocodeApi from "Services/Promocode";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PromocodeUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

  // Fetch Passenger Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        console.log(res?.data?.data?.data[0])
        setDetails(res?.data?.data?.data[0]);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    PromocodeApi.getPromocodeDetails(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleUpdatePromocode = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    let validatationPass = true;

    const data = {
    promoCode:formValues?.promoCode?.toUpperCase()|| "",
    discount: formValues?.discount,
    discountType: formValues?.discountType,
    discountUserType: formValues?.discountUserType,
    startingAt: formValues?.startingAt,
    expiresAt: formValues?.expiresAt,
    use_count: formValues?.use_count,
    description: formValues?.description
    };

    //console.log('data--->',data);

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Promocode Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update passenger",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    if (validatationPass) {
      PromocodeApi.updatePromocode(id, { ...data }).then(onSuccess, onFailure);
    }
  };

  // handle dates
  const handlestartingdate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("startingAt", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("startingAt", formattedDate);
  }
};

const handleexpiredate = (newValue) => {
  if (newValue === null || newValue === "") {
    formik.setFieldValue("expiresAt", newValue);
  } else {
    const selectedDate =
      newValue instanceof Date ? newValue : new Date(newValue);
    const parsedDate = moment(selectedDate);
    const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
    formik.setFieldValue("expiresAt", formattedDate);
  }
};  

const parseDate = (value) => {
  if (!value) return "";
  const parsedDate = moment(value);
  return parsedDate.isValid() ? parsedDate.format("MM/DD/YYYY HH:mm:ss") : "";
};

  // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(details)) {

      console.log('details?.startingAt',details?.startingAt);
      formik.setFieldValue("promoCode", details?.promoCode);
      formik.setFieldValue("discount", details?.discount);
      formik.setFieldValue("discountType", details?.discountType);
      formik.setFieldValue("discountUserType", details?.discountUserType);
      formik.setFieldValue("startingAt",parseDate(details?.startingAt));
      formik.setFieldValue("expiresAt",parseDate(details?.expiresAt));
      formik.setFieldValue("use_count", details?.use_count);
      formik.setFieldValue("description", details?.description);
    }
  }
    updateFormValues();
  }, [details]);

// Formik
const formik = useFormik({
initialValues: {
promoCode: "",
discount: "",
discountType: "",
discountUserType: "",
startingAt: "",
expiresAt: "",
use_count: "",
description: ""
},
validationSchema: yup.object({
promoCode: yup.string().required("PromoCode is required"),
discount: yup.number().typeError("discount must be a number").required("Discount is required"),
discountType: yup.string().required("Discount Type is required"),
discountUserType: yup.string().required("Discount User Type is required"),  
startingAt: yup
  .string()
  .required("Starting time is required")
  .test(
    "is-today-or-future",
    "Starting date must be today or a future date",
    (value) => {
      console.log('start value-->',value)
      if (!value) return false; // required will catch empty
      const selectedDate = moment(value, "MM/DD/YYYY HH:mm:ss", true);
      if (!selectedDate.isValid()) return false;

      // Allow today or future (not strictly after now, so same-day allowed)
      return selectedDate.isSameOrAfter(moment(), "day");
    }
  ),
expiresAt: yup
.string()
.required("Expiring time is required")
.test(
"is-future-date",
"Expiry date must be in the future",
(value) => {
  if (!value) return false; // required will handle empty
  const selectedDate = moment(value, "MM/DD/YYYY HH:mm:ss", true);
  if (!selectedDate.isValid()) return false;
  return selectedDate.isAfter(moment()); // must be > now
}
)
.test(
"is-after-startingAt",
"Expiry date must be greater than Starting date",
function (value) {
  const { startingAt } = this.parent; // access sibling field
  if (!value || !startingAt) return true; // skip if either missing
  const start = moment(startingAt, "MM/DD/YYYY HH:mm:ss", true);
  const expire = moment(value, "MM/DD/YYYY HH:mm:ss", true);
  if (!start.isValid() || !expire.isValid()) return false;
  return expire.isAfter(start);
}
),     
use_count: yup.number().typeError("Usage count must be a number").required("Usage count is required"),
description: yup.string().required("Starting time is required")  
}),
enableReinitialize: true,
onSubmit: handleUpdatePromocode,
});

  //Tabs

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Update Promocode
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
        <Grid container>
          <section className={classes.container}>
            <Grid item xs={12} className={classes.detailsContainer}>

              <Grid container className={classes.containerWrapper}>

                <Grid item xs={12} md={6} lg={6} xl={6}>

                  <Grid container>
{/* promocode*/}
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                        form: {
                              autocomplete: 'off',
                            },
                        }}
                        id="promoCode"
                        label="Promo code"
                        value={formik?.values?.promoCode}
                        defaultValue={formik?.values?.promoCode}
                        onChange={formik.handleChange}
                        error={
                          formik?.errors?.promoCode &&
                          formik?.touched?.promoCode
                        }
                        helperText={
                          formik?.errors?.promoCode &&
                          formik?.touched?.promoCode &&
                          formik?.errors?.promoCode
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      ></TextField>
                    </Grid>
{/* discount */}                 
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                        form: {
                              autocomplete: 'off',
                            },
                        }}
                        name="discount"
                        id="discount"
                        label="Discount"
                        value={formik?.values?.discount}
                        defaultValue={formik?.values?.discount}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.discount &&
                          formik?.touched?.discount
                        }
                        helperText={
                          formik?.errors?.discount &&
                          formik?.touched?.discount &&
                          formik?.errors?.discount
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      ></TextField>
                    </Grid>
{/* discount type */}
                        <Grid
                          item
                          md={6}
                          lg={6}
                          xl={6}
                          className={classes.textFieldWrapper}
                        >
                          <TextField
                            inputProps={{
                            form: {
                                  autocomplete: 'off',
                                },
                            }}
                            name="discountType"
                            id="discountType"
                            label="Discount Type"
                            value={formik?.values?.discountType}
                            defaultValue={formik?.values?.discountType}
                            onChange={formik?.handleChange}
                            select
                            error={
                              formik?.errors?.discountType &&
                              formik?.touched?.discountType
                            }
                            helperText={
                              formik?.errors?.discountType &&
                              formik?.touched?.discountType &&
                              formik?.errors?.discountType
                            }
                            fullWidth
                            variant="outlined"
                            size="small"
                          >
                            <MenuItem key="percentage" value="PERCENTAGE">
                            Percentage
                            </MenuItem>

                            <MenuItem key="flat" value="FLAT">
                            Flat
                            </MenuItem> 
                          </TextField>
                        </Grid>
{/* user type */}
                        <Grid
                          item
                          md={6}
                          lg={6}
                          xl={6}
                          className={classes.textFieldWrapper}
                        >
                          <TextField
                            inputProps={{
                            form: {
                                  autocomplete: 'off',
                                },
                            }}
                            name="discountUserType"
                            id="discountUserType"
                            label="User Type"
                            value={formik?.values?.discountUserType}
                            defaultValue={formik?.values?.discountUserType}
                            onChange={formik?.handleChange}
                            select
                            error={
                              formik?.errors?.discountUserType &&
                              formik?.touched?.discountUserType
                            }
                            helperText={
                              formik?.errors?.discountUserType &&
                              formik?.touched?.discountUserType &&
                              formik?.errors?.discountUserType
                            }
                            fullWidth
                            variant="outlined"
                            size="small"
                          >
                            <MenuItem key="allusers" value="ALL">
                            All Users
                            </MenuItem>

                            <MenuItem key="newusers" value="NEW">
                            New Users
                            </MenuItem> 
                          </TextField>
                        </Grid>

                  </Grid>

                </Grid>

                <Grid item xs={12} md={6} lg={6} xl={6}>
                  <Grid container>

{/* starting At*/}
                        <Grid
                          item
                          md={12}
                          lg={12}
                          xl={12}
                          className={classes.textFieldWrapper}
                        >
<div className={classes.datePickerStyle}> 
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
label="Starting At"
  value={formik.values.startingAt ? dayjs(formik.values.startingAt, "MM/DD/YYYY HH:mm:ss") : null}
  onChange={(newValue) => {
   handlestartingdate(newValue);
  }}
  slotProps={{
    textField: {
      error: formik.touched.startingAt && Boolean(formik.errors.startingAt),
      helperText: formik.touched.startingAt && formik.errors.startingAt,
    }
  }}
size="small"
renderInput={(params) => (
<TextField
  {...params}
  error={
    formik?.errors?.startingAt &&
    formik?.touched?.startingAt
  }
  helperText={
    formik?.errors?.startingAt &&
    formik?.touched?.startingAt &&
    formik?.errors?.startingAt
  }
/>
)}
/>
</LocalizationProvider>
</div>
                        </Grid>

{/* expiring At*/}
                        <Grid
                          item
                          md={12}
                          lg={12}
                          xl={12}
                          className={classes.textFieldWrapper}
                        >
<div className={classes.datePickerStyle}> 
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DatePicker
label="Expiring At"
  value={formik.values.expiresAt ? dayjs(formik.values.expiresAt, "MM/DD/YYYY HH:mm:ss") : null}
  onChange={(newValue) => {
    handleexpiredate(newValue);
  }}
  slotProps={{
    textField: {
      error: formik.touched.expiresAt && Boolean(formik.errors.expiresAt),
      helperText: formik.touched.expiresAt && formik.errors.expiresAt,
    }
  }}
size="small"
renderInput={(params) => (
<TextField
  {...params}
  error={
    formik?.errors?.expiresAt &&
    formik?.touched?.expiresAt
  }
  helperText={
    formik?.errors?.expiresAt &&
    formik?.touched?.expiresAt &&
    formik?.errors?.expiresAt
  }
/>
)}
/>
</LocalizationProvider>
</div>
                        </Grid>

{/* Usage count */}                 
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                        form: {
                              autocomplete: 'off',
                            },
                        }}
                        name="use_count"
                        id="use_count"
                        label="Usage count"
                        value={formik?.values?.use_count}
                        defaultValue={formik?.values?.use_count}
                        onChange={formik?.handleChange}
                        error={
                          formik?.errors?.use_count &&
                          formik?.touched?.use_count
                        }
                        helperText={
                          formik?.errors?.use_count &&
                          formik?.touched?.use_count &&
                          formik?.errors?.use_count
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                      ></TextField>
                    </Grid>

{/* description*/}
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className={classes.textFieldWrapper}
                    >
                      <TextField
                        inputProps={{
                        form: {
                              autocomplete: 'off',
                            },
                        }}
                        id="description"
                        label="Description"
                        value={formik?.values?.description}
                        defaultValue={formik?.values?.description}
                        onChange={formik.handleChange}
                        error={
                          formik?.errors?.description &&
                          formik?.touched?.description
                        }
                        helperText={
                          formik?.errors?.description &&
                          formik?.touched?.description &&
                          formik?.errors?.description
                        }
                        fullWidth
                        variant="outlined"
                        size="small"
                        multiline
                        rows={4} 
                      ></TextField>
                    </Grid>

                  </Grid>
                </Grid>

              </Grid>

              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.sbtBtnWrapper}
                >
                  <Button variant="contained" onClick={formik?.handleSubmit}>
                    Update Promocode
                  </Button>
                </Grid>
              </Grid>

            </Grid>
          </section>
        </Grid>

        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose}>Close</Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PromocodeUpdate;
